import { ReactNode } from "react";

import { useAppTheme, Theme } from "@bridgesplit/react";
import { MenuItemProps, MenuItems, Text } from "@bridgesplit/ui";
import { AutoMode, LightModeOutlined, DarkModeOutlined, CheckOutlined } from "@mui/icons-material";

export function ThemeSwitch({ close }: { close: () => void }) {
    const { theme, updateTheme } = useAppTheme();

    const options: { value: Theme; label: string; icon: ReactNode }[] = [
        { value: "auto", label: "Device (auto)", icon: <AutoMode /> },
        { value: "light", label: "Light", icon: <LightModeOutlined /> },
        { value: "dark", label: "Dark", icon: <DarkModeOutlined /> }
    ];
    const items = options.map(
        (option): MenuItemProps => ({
            text: option.label,
            onClick: () => updateTheme(option.value),
            icon: option.icon,
            rowEnd:
                theme === option.value ? (
                    <Text>
                        <CheckOutlined />
                    </Text>
                ) : undefined
        })
    );

    return <MenuItems close={close} items={items} />;
}
